import { PhoneDisabled } from "@mui/icons-material";
import PropTypes from "prop-types";
import React from "react";

import { getColor } from "../ui/getColor";
import InfoToolTip from "../ui/InfoToolTip";
import indicatorColors from "../utils/indicatorColors";
import STRINGS from "../utils/strings";

const DoNotContact = ({ minorCheck }) => {
  const getAgeColor = (value) => {
    if (getColor(value) === indicatorColors.green) {
      return indicatorColors.black;
    }
    return getColor(minorCheck);
  };
  return (
    <div id="Do-Not-Contact" data-test-id="Do-Not-Contact">
      <span style={{ color: getAgeColor(minorCheck) }} className="flex">
        <InfoToolTip
          itemList={STRINGS.DO_NOT_CONTACT}
          headerTitle={"Do Not Contact"}
          icon={<PhoneDisabled fontSize="inherit" className="m-2 h-[13px] w-[13px]" />}
        >
          <PhoneDisabled fontSize="inherit" />
        </InfoToolTip>
      </span>
    </div>
  );
};
export default DoNotContact;

DoNotContact.propTypes = {
  minorCheck: PropTypes.any,
};
